import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
  useEffect,
} from 'react';

import { Checkbox, FormControlLabel, Typography, styled } from '@mui/material';
import {
  Remove as RemoveIcon,
  Check as CheckIcon,
  CheckBoxOutlineBlank,
} from '@mui/icons-material';

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  height: '18px !important',
  width: '18px !important',
  marginLeft: 11,
  '&.MuiCheckbox-colorSecondary.Mui-checked': {
    color: theme.palette.primary.main,
  },
  '&:hover': {
    backgroundColor: 'transparent !important',
  },
}));
const StyledCheckboxOutline = styled(CheckBoxOutlineBlank)(({ variant }) => ({
  ...variant,
  width: 18,
  height: 18,
  margin: 3,
}));
const StyledCheckedIcon = styled(CheckIcon)(({ theme }) => ({
  background: theme.palette.primary.main + '!important',
  color: 'white !important',
  width: 18,
  height: 18,
  margin: 3,
}));

const StyledRemoveIcon = styled(RemoveIcon)(({ theme }) => ({
  background: theme.palette.primary.main + '!important',
  color: 'white !important',
  width: 18,
  height: 18,
  margin: 3,
}));

const CustomFormControlLabel = styled(FormControlLabel)({
  marginBottom: 16,
  paddingBottom: 0,
  color: 'black',
  fontWeight: 'bold',
  fontSize: 14,
});

const variants = {
  greyLight: {
    background: '#F8F6FA !important',
    color: '#F8F6FA !important',
  },
  grey: {
    background: '#ADADAD !important',
    color: '#ADADAD !important',
  },
  white: {
    background: 'white !important',
    color: 'white !important',
  },
  whiteOutlined: {
    background: 'white !important',
    color: '#333333 !important',
  },
  black: {
    background: 'transparent !important',
    color: 'black !important',
  },
};
/* eslint-disable */
export const CustomCheckbox = forwardRef(
  (
    {
      variant = 'grey',
      label,
      labelPlacement = 'top',
      isSelected = false,
      customFont = false,
      ...rest
    },
    ref
  ) => {
    useImperativeHandle(ref, () => ({
      customReset() {
        setChecked(false);
      },
    }));
    const [checked, setChecked] = useState(false);
    const checkboxRef = useRef(null);
    const handleChange = (e) => {
      setChecked(e.target.checked);
    };

    useEffect(() => {
      setChecked(isSelected);
    }, [isSelected]);

    return (
      <CustomFormControlLabel
        style={{ position: 'relative', width: '100%' }}
        control={
          <StyledCheckbox
            onChange={handleChange}
            checked={checked}
            ref={checkboxRef}
            icon={<StyledCheckboxOutline variant={variants[variant]} />}
            checkedIcon={<StyledCheckedIcon />}
            indeterminateIcon={<StyledRemoveIcon />}
            {...rest}
            disableRipple
          />
        }
        label={
          <Typography
            variant={'body2'}
            style={{
              paddingLeft: 50,
              position: 'absolute',
              width: '100%',
            }}
            lineHeight={'16px'}
          >
            {label}
          </Typography>
        }
        labelPlacement={labelPlacement}
      />
    );
  }
);
/* eslint-enabled */
